import { ca } from '@cian/analytics';

// Добавление ЖК в избранное
export function trackAddToFavorites(gaLabel: string, newbuildingId: number, action?: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: action || 'add_from_card_JK',
    label: gaLabel,
    oid: newbuildingId,
    useLastProducts: true,
  });
}

// Удаление ЖК из избранного
export function trackRemoveFromFavorites(gaLabel: string, newbuildingId: number, action?: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: action || 'remove_from_card_JK',
    label: gaLabel,
    oid: newbuildingId,
    useLastProducts: true,
  });
}
